import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconHighlights$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHighlights extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ff6bd3f7a32c32c84945c294df7fda308281a747', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f6325260c7a0fc527e8ea8a64f18c71e94e8f6fa', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ad14e57d103e4102d5ed608441f7b13f1e4c2c1c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.15 4.15a.5.5 0 0 0-.36-.15H6.26a.52.52 0 0 0-.35.14L2.32 7.68a.5.5 0 0 0 0 .67l8.38 10.27a.4.4 0 0 0 .62 0l8.4-10.27a.5.5 0 0 0 0-.67zm-5.9 11.56L4.71 9l5.54.69zm1.5-6.1 5.66-.81-5.66 6.92zM18 8.13v-.06zM15.38 5.5l1.82 1.82-5.45.77V5.5zm-8.71 0h3.58v2.63l-5.54-.7z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-highlights", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-highlights"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-highlights":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHighlights$1);
            }
            break;
    } });
}

const CosmosIconHighlights = CosmosIconHighlights$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHighlights, defineCustomElement };
